import { useId } from "react";

import ExpandIcon from "@mui/icons-material/ExpandMore";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { AccordionKey } from "@shared";

import { PersistentAccordion } from "@/common/components/persistent-accordion/PersistentAccordion";

interface Props {
  title: string;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  disableExpand?: boolean;
  accordionKey: AccordionKey;
}

const accordionSx: SxProps<Theme> = {
  border: "none",
  boxShadow: "none",
  "&::before": { display: "none" },
};

export function ClientAccordion({ title, children, defaultExpanded, disableExpand, accordionKey }: Props) {
  const id = useId();
  return (
    <PersistentAccordion
      disableGutters
      sx={accordionSx}
      defaultExpanded={defaultExpanded}
      expanded={disableExpand ? true : undefined}
      storageKey={accordionKey}
    >
      <AccordionSummary
        expandIcon={disableExpand ? null : <ExpandIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Typography variant="h5">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails id={`${id}-content`}>{children}</AccordionDetails>
    </PersistentAccordion>
  );
}
